import { RoleNameEnum } from '@/bundles/Roles/types';

export default class Role {
  id: number;
  name: RoleNameEnum;

  constructor (data: Role) {
    this.id = data.id;
    this.name = data.name;
  }
}
